import verificationMessages from '../../../verification-error-messages.js';
import password_rejected from './password-rejected.js';
const error = {
    ...verificationMessages,
    general_required: `{{types, list(type: disjunction;)}} จำเป็นต้องระบุ`,
    general_invalid: `{{types, list(type: disjunction;)}} ไม่ถูกต้อง`,
    invalid_min_max_input: 'ค่าที่กรอกควรอยู่ระหว่าง {{minValue}} และ {{maxValue}}',
    invalid_min_max_length: 'จำนวนตัวอักษรที่กรอกควรอยู่ระหว่าง {{minLength}} และ {{maxLength}}',
    username_required: 'ต้องระบุชื่อผู้ใช้',
    password_required: 'ต้องระบุรหัสผ่าน',
    username_exists: 'ชื่อผู้ใช้นี้มีอยู่แล้ว',
    username_should_not_start_with_number: 'ชื่อผู้ใช้ไม่ควรขึ้นต้นด้วยตัวเลข',
    username_invalid_charset: 'ชื่อผู้ใช้ควรมีแค่ตัวอักษร ตัวเลข หรือขีดล่างเท่านั้น',
    username_too_short: 'ชื่อผู้ใช้ต้องมีความยาวอย่างน้อย {{min}} ตัวอักษร',
    username_too_long: 'ชื่อผู้ใช้ต้องยาวไม่เกิน {{max}} ตัวอักษร',
    username_uppercase_not_allowed: 'ไม่อนุญาตให้ใช้ตัวอักษรพิมพ์ใหญ่ในชื่อผู้ใช้',
    username_lowercase_not_allowed: 'ไม่อนุญาตให้ใช้ตัวอักษรพิมพ์เล็กในชื่อผู้ใช้',
    username_numbers_not_allowed: 'ไม่อนุญาตให้ใช้ตัวเลขในชื่อผู้ใช้',
    username_underscore_not_allowed: 'ไม่อนุญาตให้ใช้ขีดล่างในชื่อผู้ใช้',
    invalid_email: 'อีเมลไม่ถูกต้อง',
    invalid_phone: 'หมายเลขโทรศัพท์ไม่ถูกต้อง',
    passwords_do_not_match: 'รหัสผ่านไม่ตรงกัน',
    invalid_passcode: 'รหัสยืนยันไม่ถูกต้อง',
    device_code_required: 'จำเป็นต้องระบุรหัส',
    invalid_device_code: 'รหัสอุปกรณ์ไม่ถูกต้อง',
    device_flow_aborted: 'คำขอเข้าสู่ระบบถูกขัดจังหวะ',
    invalid_connector_auth: 'การอนุญาตไม่ถูกต้อง',
    invalid_connector_request: 'ข้อมูลตัวเชื่อมต่อไม่ถูกต้อง',
    unknown: 'เกิดข้อผิดพลาดที่ไม่ทราบสาเหตุ',
    invalid_session: 'ไม่พบเซสชัน กรุณากลับไปและเข้าสู่ระบบอีกครั้ง',
    timeout: 'หมดเวลา',
    password_rejected,
    sso_not_enabled: 'ยังไม่ได้เปิดใช้งาน Single Sign-On สำหรับบัญชีอีเมลนี้',
    invalid_link: 'ลิงก์ไม่ถูกต้อง',
    invalid_link_description: 'โทเค็นใช้ครั้งเดียวของคุณอาจหมดอายุหรือไม่ถูกต้องอีกต่อไป',
    captcha_verification_failed: 'การตรวจสอบ captcha ล้มเหลว',
    terms_acceptance_required: 'จำเป็นต้องยอมรับเงื่อนไข',
    terms_acceptance_required_description: 'คุณต้องยอมรับเงื่อนไขเพื่อดำเนินการต่อ',
    something_went_wrong: 'เกิดข้อผิดพลาดบางอย่าง',
    access_denied: 'ปฏิเสธการเข้าถึง',
    application_access_denied: 'คุณไม่มีสิทธิ์เข้าถึงแอปพลิเคชันนี้\nกรุณาติดต่อผู้ดูแลระบบเพื่อขอความช่วยเหลือ',
    feature_not_enabled: 'คุณไม่มีสิทธิ์เข้าถึงฟีเจอร์นี้ กรุณาติดต่อผู้ดูแลระบบเพื่อขอความช่วยเหลือ',
};
export default Object.freeze(error);
